@if (loading) {
<app-loader></app-loader>
} @else {
<router-outlet></router-outlet>
}
